import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CLIENTE} from '@pcgerente-node/pcg-comun/dist/DTOs';
import { RootState, useAppDispatch } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { obtenerAgenciasDelDestinatario } from '../../../redux/actions/actionsConsulta';
import Loading from '../Loading/Loading';

interface ChildProps {
  cliente: CLIENTE
}

const ModalVerAgencias: React.FC<ChildProps> = ({ cliente }) => {

  const dispatch = useAppDispatch()
  const [show, setShow] = useState(false);

  const agenciasDestinatarioSeleccionado = useSelector((state:RootState) => state.consulta.agenciasDestinatarioSeleccionado)
  
  function limpiarDatos(){
    setShow(false)
  }
  
  function estadoInicial() {
    setShow(true)
  }

  useEffect(() => {
    if(cliente.id && show){
      dispatch(obtenerAgenciasDelDestinatario(cliente.id))
    }
  },[show])


  return (
    <>
      <button className='btn-verAgencias-misDestinatarios' onClick={() => estadoInicial()}>
        Ver Agencias
      </button>

      <Modal show={show} 
        onHide={() =>limpiarDatos()}
        centered 
        animation={false}
       >
        <Modal.Header>
          <Modal.Title>
            <div className='text-center'>
               {cliente.razonSocial}
              </div>
          </Modal.Title>
        </Modal.Header>
        
        <Modal.Body>
          {agenciasDestinatarioSeleccionado.loading === false?
          agenciasDestinatarioSeleccionado.info.length>0?
            <>
              <table id='tablaBlock' className="table table-responsive " >
                <thead>
                  <tr className="table-primary">
                    <th>Descripción</th>
                    <th>Establecimiento</th>
                    <th>Dirección</th>
                    <th>telefono1</th>
                  </tr>
                </thead>
                <tbody>
                  {agenciasDestinatarioSeleccionado.info.map((establecimiento, i) =>
                    <tr key={i}>
                      <td>{establecimiento.descripcion}</td>
                      <td>{establecimiento.establecimiento}</td>
                      <td>{establecimiento.direccion}</td>
                      <td>{establecimiento.telefono1}</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </>
            :<div className='mt-3 mb-3 text-center'>
              <h5 className='text-danger'>Aún no hay agencias disponibles</h5>
            </div>
          : 
          <Loading/>
          }
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-primary' onClick={() => limpiarDatos()}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalVerAgencias;